import { useCallback, useEffect, useState } from 'react';

import { clearToken, getToken, onTokenRejected, setToken } from '@/api/client';

interface AuthState {
  token: string | null;
}

export function useAuth() {
  const [state, setState] = useState<AuthState>({ token: getToken() });

  useEffect(() => onTokenRejected(() => setState({ token: null })), []);

  const signIn = useCallback((token: string) => {
    setToken(token);
    setState({ token });
  }, []);

  const signOut = useCallback(() => {
    clearToken();
    setState({ token: null });
  }, []);

  return { token: state.token, signIn, signOut };
}
